import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import paymentsFormEn from '../../i18n/paymentsForm/en.json';
import paymentsFormRu from '../../i18n/paymentsForm/ru.json';
import paymentsFormAf from '../../i18n/paymentsForm/af.json';
import paymentsFormAz from '../../i18n/paymentsForm/az.json';
import paymentsFormBn from '../../i18n/paymentsForm/bn.json';
import paymentsFormEs from '../../i18n/paymentsForm/es.json';
import paymentsFormPt from '../../i18n/paymentsForm/pt.json';
import paymentsFormTr from '../../i18n/paymentsForm/tr.json';
import paymentsFormUz from '../../i18n/paymentsForm/uz.json';
import paymentsFormZh from '../../i18n/paymentsForm/zh.json';

const defaultNs = {
  paymentsForm: paymentsFormEn
}

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'pt', 'es', 'az', 'zh', 'uz', 'af', 'ru',  'tr', 'bn', 'ar'],
    ns: ['paymentsForm'],
    defaultNS: 'paymentsForm',
    resources: {
      en: defaultNs,
      ru: {
        paymentsForm: paymentsFormRu
      },
      pt: {
        paymentsForm: paymentsFormPt
      },
      es: {
        paymentsForm: paymentsFormEs
      },
      az: {
        paymentsForm: paymentsFormAz
      },
      zh: {
        paymentsForm: paymentsFormZh
      },
      uz: {
        paymentsForm: paymentsFormUz
      },
      af: {
        paymentsForm: paymentsFormAf
      },
      tr: {
        paymentsForm: paymentsFormTr
      },
      bn: {
        paymentsForm: paymentsFormBn
      },
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
